import { useEffect } from "react";

/**
 * Injects JSON-LD structured data into <head>.
 *
 * Multiple JsonLd components can coexist on the same page — each uses a unique
 * `id` so React (re)renders update the existing <script> tag in-place rather
 * than appending duplicates.
 *
 * Usage:
 *   <JsonLd id="app-detail" data={{ "@context": "https://schema.org", ... }} />
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (typeof document === "undefined" || !data) return;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.id = scriptId;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.text = JSON.stringify(data);
    return () => {
      const stale = document.getElementById(scriptId);
      if (stale) stale.remove();
    };
  }, [id, data]);
  return null;
};

export default JsonLd;
